import type { ISubscriptionResponse } from '@escloud/types';

import type { ApiClient } from './api-client';

// Read-only by design. Purchases go through purchase intents (ESCLOUD-330) and
// plan changes through the Billing Portal; the direct subscribe endpoint this
// used to post to has been retired. Cancellation is the Billing Portal's UI
// (ESCLOUD-290) - the client keeps no cancel path either. The API's DELETE
// endpoint remains as the server-side escape hatch.
export class SubscriptionsService {
    constructor(private api: ApiClient) {}

    getSubscription(tenantId: string): Promise<ISubscriptionResponse> {
        return this.api.get<ISubscriptionResponse>(`/tenants/${tenantId}/subscription`);
    }
}
